import React, { useEffect, useState } from "react";
import axios from "axios";
import Constants from "Helpers/Constants";

import {
  Card,
  Grid,
  IconButton,
  Tooltip,
} from "@mui/material";

import DeleteIcon from "@mui/icons-material/Delete";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import MDSnackbar from "components/MDSnackbar";

const TrustedBy = () => {
  const [files, setFiles] = useState([]);
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);

  const [notification, setNotification] = useState(false);
  const [message, setMessage] = useState("");
  const [notiColor, setNotiColor] = useState("success");

  /* ================= FETCH ================= */
  const fetchData = async () => {
    try {
      const res = await axios.get(Constants.getUrls.trusted);
      setList(res.data.data || []);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  /* ================= UPLOAD ================= */
  const handleUpload = async () => {
    if (!files.length) {
      setNotiColor("warning");
      setMessage("Please select files");
      setNotification(true);
      return;
    }

    const fd = new FormData();
    files.forEach((file) => fd.append("images", file));

    try {
      setLoading(true);

      await axios.post(Constants.postUrls.trusted, fd);

      setNotiColor("success");
      setMessage("Uploaded successfully");
      setNotification(true);

      setFiles([]);
      fetchData();
    } catch (err) {
      setNotiColor("error");
      setMessage("Upload failed");
      setNotification(true);
    } finally {
      setLoading(false);
    }
  };

  /* ================= DELETE ================= */
  const handleDelete = async (id) => {
    if (!window.confirm("Delete this image?")) return;

    try {
      await axios.delete(Constants.deleteUrls.trusted + id);

      setNotiColor("success");
      setMessage("Deleted successfully");
      setNotification(true);

      fetchData();
    } catch (err) {
      setNotiColor("error");
      setMessage("Delete failed");
      setNotification(true);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <MDBox pt={6} pb={3}>
        <Card>
          <MDBox
            mx={2}
            mt={-3}
            py={3}
            px={2}
            bgColor="info"
            borderRadius="lg"
          >
            <MDTypography variant="h6" color="white">
              Trusted By
            </MDTypography>
          </MDBox>

          {/* ================= UPLOAD ================= */}
          <MDBox p={3}>
            <Grid container spacing={2}>
              <Grid item sm={6}>
                <input
                  type="file"
                  multiple
                  onChange={(e) => setFiles([...e.target.files])}
                />
              </Grid>

              <Grid item sm={6}>
                <MDButton
                  variant="contained"
                  color="info"
                  onClick={handleUpload}
                  disabled={loading}
                >
                  {loading ? "Uploading..." : "Upload"}
                </MDButton>
              </Grid>
            </Grid>
          </MDBox>

          {/* ================= LIST ================= */}
          <MDBox px={3} pb={3}>
            <Grid container spacing={2}>
              {list.map((item) => (
                <Grid item xs={6} sm={3} key={item._id}>
                  <div
                    style={{
                      border: "1px solid #eee",
                      padding: "10px",
                      borderRadius: "8px",
                      textAlign: "center",
                    }}
                  >
                    <img
                      src={Constants.imageDomain + item.image}
                      alt=""
                      style={{
                        width: "100%",
                        height: "120px",
                        objectFit: "contain",
                      }}
                    />

                    <Tooltip title="Delete">
                      <IconButton
                        color="error"
                        onClick={() => handleDelete(item._id)}
                      >
                        <DeleteIcon />
                      </IconButton>
                    </Tooltip>
                  </div>
                </Grid>
              ))}
            </Grid>
          </MDBox>

          <MDSnackbar
            color={notiColor}
            title="Trusted By"
            content={message}
            open={notification}
            onClose={() => setNotification(false)}
          />
        </Card>
      </MDBox>
    </DashboardLayout>
  );
};

export default TrustedBy;